export const TONAPI_API_URL = 'https://tonapi.io/v2';
export const TONCENTER_API_V3_URL = 'https://toncenter.com/api/v3';
